import type { AxiosError } from 'axios'

import * as Sentry from '@sentry/react'

import { router } from '~/app/router'
import env from '~/environments'
import { ifAxiosErrorAddContext } from '~/utils/sentry'

Sentry.init({
	enabled: env.appEnv !== 'dev',
	environment: env.appEnv,
	release: env.version,
	dsn: env.sentryDsn,
	integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router), Sentry.replayIntegration()],
	tracesSampleRate: 1.0,
	tracePropagationTargets: ['localhost', env.apiUrl],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	beforeSend(event, hint) {
		if (hint.originalException) {
			event.contexts = ifAxiosErrorAddContext(event.contexts, hint.originalException as AxiosError)
		}

		return event
	}
})
